import { render, staticRenderFns } from "./PatientTypesTable.vue?vue&type=template&id=12aefff6&"
import script from "./PatientTypesTable.vue?vue&type=script&lang=js&"
export * from "./PatientTypesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports